(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');

    if (!viewport || slides.length < 2) return;

    const goTo = (index) => {
      const safeIndex = (index + slides.length) % slides.length;
      viewport.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: 'smooth' });
    };

    const currentIndex = () => {
      const width = viewport.clientWidth || 1;
      return Math.round(viewport.scrollLeft / width);
    };

    const updateDots = () => {
      const index = Math.min(slides.length - 1, Math.max(0, currentIndex()));
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    };

    previous?.addEventListener('click', () => goTo(currentIndex() - 1));
    next?.addEventListener('click', () => goTo(currentIndex() + 1));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(Number(dot.dataset.carouselDot)));
    });

    let scrollTimer;
    viewport.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateDots, 60);
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
